import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { sessionSelectors } from 'store/state/selectors';

/**
 * Hook para obter o producerUrl de forma consistente
 * Prioriza o valor do Redux, fallback para params da URL
 */
export const useProducerUrl = (): string => {
  const producerUrlFromRedux = useSelector(sessionSelectors.getProducerUrl);
  const { producer } = useParams<{ producer: string }>();
  
  return producerUrlFromRedux || producer || '';
};
